import { Outlet } from 'react-router-dom';

import * as St from './Layout.styles';

import { StepName } from '~/core/enums';
import { useAppSelector } from '~/redux/hooks';
import { selectFocusElement } from '~/redux/slices/layout';
import { selectStepState } from '~/redux/slices/stepper';
import NextStepButton from '~atoms/NextStepButton';
import NavStepper from '~molecules/NavStepper';
import Header from '~organisms/Header';
import NavBar from '~organisms/NavBar';

const Layout = () => {
  // global element
  const focusElement = useAppSelector(selectFocusElement);

  // required states
  const stepState = useAppSelector(selectStepState);

  return (
    <St.Container>
      <Header>
        <NavBar>
          <NavStepper />
        </NavBar>
      </Header>

      <St.MainContent>
        <Outlet />

        {stepState.current !== StepName.orderSummary && !focusElement && (
          <St.NextStepContainer>
            <NextStepButton />
          </St.NextStepContainer>
        )}
      </St.MainContent>
    </St.Container>
  );
};

export default Layout;
